class SubscriptionForm extends HTMLElement {
  constructor() {
    super();
    this.form = null;
    this.emailInput = null;
    this.responseElement = null;
    this.submitButton = null;
    this.privacyPolicies = null;
    this.controller = new AbortController();
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    this.emailInput = this.querySelector('[data-email-input]');
    this.responseElement = this.querySelector('[data-form-response]');
    this.successMessage =
      this.getAttribute('data-success-message') ||
      'Thank you for signing up. We look forward to share our journey with you.';
    this.errorMessage =
      this.getAttribute('data-error-message') ||
      'Something went wrong. Please try again.';
    this.submitButton = this.querySelector('[data-submit-button]');
    this.privacyPolicies = document.querySelector('[data-privacy-policies]');

    if (this.form) {
      this._boundHandleSubmit = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this._boundHandleSubmit, {
        signal: this.controller.signal,
      });
    }

    if (this.emailInput) {
      this.emailInput.addEventListener(
        'keyup',
        () => {
          this.toggleSubmitButton();
        },
        { signal: this.controller.signal }
      );
    }
  }

  validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  toggleSubmitButton() {
    if (!this.emailInput || !this.submitButton || !this.privacyPolicies) return;
    if (
      this.emailInput.value.length > 0 &&
      this.validateEmail(this.emailInput.value)
    ) {
      this.submitButton.classList.remove('hidden');
      this.privacyPolicies.classList.remove('opacity-0');
    } else {
      this.submitButton.classList.add('hidden');
      this.privacyPolicies.classList.add('opacity-0');
    }
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this._boundHandleSubmit);
    this.controller.abort();
  }

  async handleSubmit(event) {
    event.preventDefault();

    const email = this.emailInput?.value;
    if (!email) return;

    const listId = this.getAttribute('list-id');

    const formData = new URLSearchParams({
      g: listId,
      $fields: 'email',
      email: email,
      $source: 'Custom Forms',
    });

    try {
      const response = await fetch(
        'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
          },
          body: formData.toString(),
        }
      );

      if (!response.ok) {
        this.showResponse(this.errorMessage);
        return;
      }
      const data = await response.json();

      if (data.data?.is_subscribed) {
        this.showResponse(this.successMessage);
      } else {
        this.showResponse(this.errorMessage);
      }
    } catch {
      this.showResponse(this.errorMessage);
    } finally {
      this.form.reset();
    }
  }

  showResponse(message) {
    if (this.responseElement) {
      this.responseElement.textContent = message;
      setTimeout(() => {
        this.responseElement.textContent = '';
      }, 5000);
    }
  }
}

if (!customElements.get('subscription-form')) {
  customElements.define('subscription-form', SubscriptionForm);
}
